module.exports = __webpack_public_path__ + "assets/images/stopwatch-on.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/stopwatch-on.png
// module id = 1527
// module chunks = 1